interface MarkdownToHtmlArgs {
  markdown: string;
  boldTag?: string;
  italicTag?: string;
}

export const markdownToHtml = ({
  markdown,
  boldTag = 'b',
  italicTag = 'i',
}: MarkdownToHtmlArgs) => {
  return markdown
    .replace(/\*\*(.*?)\*\*/g, `<${boldTag}>$1</${boldTag}>`)
    .replace(/_(.*?)_/g, `<${italicTag}>$1</${italicTag}>`)
    .replace(/\++(.*?)\++/g, '<u>$1</u>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/, '<a href="$2">$1</a>');
};
